import { createAction } from "@reduxjs/toolkit";

const setClosedSession = createAction("SET_CLOSED_SESSION");
export default setClosedSession;
